export default __webpack_public_path__ + "static/media/5.77c8a3e9.png";